const getters = {
    userInfo: state => state.app.userInfo
  }
  export default getters
  